var render = function (_h,_vm) {var _c=_vm._c;return _c('a',{class:[_vm.data.class, _vm.data.staticClass],attrs:{"href":("mailto:" + (_vm.props.email))}},[_vm._v("\n  "+_vm._s(_vm.props.email)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }